import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import RoutesSetup from "./routes/RoutesSetup";
import { BrowserRouter } from "react-router-dom";

import { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Modal from "react-modal";
import erody from "./const/erody";

Modal.setAppElement("#root");
const { art, erody2 } = erody();
console.log(art, erody2);
function App() {
  return (
    <SkeletonTheme baseColor="#f5f5f5" highlightColor="#FFFFFF">
      <BrowserRouter>
        <ScrollToTop>
          <RoutesSetup />
        </ScrollToTop>
      </BrowserRouter>
    </SkeletonTheme>
  );
}

export default App;
